import FieldsPayStubCompanyInfo from './FieldsPayStubCompanyInfo'

export default FieldsPayStubCompanyInfo
